import RefreshIcon from '@mui/icons-material/Refresh'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'

interface Props {
  repeatInterval: string
}

export const JobSchedulerRepeatInterval = ({ repeatInterval }: Props) => {
  return (
    <Chip
      avatar={
        <Avatar>
          <RefreshIcon
            sx={{
              color: 'white',
              cursor: 'default',
              backgroundColor: 'inherit',
            }}
          />
        </Avatar>
      }
      variant="outlined"
      color="primary"
      label={repeatInterval}
      sx={{
        width: '120px',
        backgroundColor: 'white',
      }}
    />
  )
}
